/* eslint-disable no-console */
import store from '../store';
import Vue from 'vue';
import { EventBus } from '../api/eventbus';
import StatsService from '../services/stats.service';
import * as types from '../store/mutation-types';

let counter = 0;

const collectStats = () => {
        const points = store.state.upgrades.all.reduce(
            (acc, upgrade) => acc + (upgrade.isApplied === true ? upgrade.idx : 0),
            store.state.shops.all.reduce(
                (acc, shop) => acc + shop.amount * shop.grade,
                0
            )
        );
        store.commit({
            type: types.SET_POINTS,
            points
        });
        return points;
    }, onTick = () => {
        if (store.state.game.onStrike) {
            return;
        }
        let finishAt,
            secondsElapsed,
            updates = [];
        const now = Date.now(); // does not work in mobile safari: window.performance.now();
        if (++counter === 360) {
            StatsService.postStats(collectStats());
            counter = 0;
        }
        store.state.game.productionQueue.forEach((currentQueueEntry, index) => {
            finishAt = currentQueueEntry.start + currentQueueEntry.productionTime;
            if (currentQueueEntry.finished === true) {
                store.commit({
                    type:  'CLEANUP_QUEUE',
                    index,
                    currentQueueEntry
                });
            } else if (now >= finishAt) {
                store.commit({
                    type: 'FINISH_PRODUCTION',
                    currentQueueEntry,
                    now
                });
                store.commit({
                    type:   'INCREASE_BALANCE',
                    amount: currentQueueEntry.shop.earnings
                });
                if (store.state.tutorial.step.id === 3) {
                    store.commit('SET_STEP', 4);
                } else if (store.state.tutorial.step.id === 5 && store.state.game.balance.toString() >= 60) {
                    store.commit('SET_STEP', 6);
                } else if (store.state.tutorial.step.id === 7 && store.state.game.balance.toString() >= 1000) {
                    store.commit('SET_STEP', 8);
                } else if (store.state.tutorial.step.id === 11) {
                    store.commit('SET_STEP', -1);
                    EventBus.$emit('addMessage', {
                        type:        'success',
                        text:        Vue.i18n.translate('TUTORIAL_FINISHED_TEXT'),
                        headline:    Vue.i18n.translate('TUTORIAL_FINISHED_HEADLINE'),
                        dismissible: true,
                        check:       false,
                        timeout:     10000
                    });
                }
            } else if (currentQueueEntry.doUpdate) {
                secondsElapsed = now - currentQueueEntry.start;
                updates.push({
                    progress:  Math.floor(secondsElapsed / currentQueueEntry.productionTime * 100),
                    remaining: (currentQueueEntry.productionTime - secondsElapsed) / 1000,
                    id:        currentQueueEntry.shop.id
                });
            }
        });
        store.commit('UPDATE_PRODUCTION_PROGRESSES', updates);
        if (counter % 20 === 0) {
            store.commit('SAVE_GAME');
        }
    };

export default {
    collectStats, onTick
};
